import React, { useCallback, useRef } from 'react';
import { GlobalStyle } from '../../styles/global';
import logoImg from '../../assets/metodo-billings-marca-dashboard.png';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../components/Elements/Input';
import Button from '../../components/Elements/Button';
import { Container } from '../SignIn/styles';
import getValidationErros from '../../utils/getValidationErros';
import {api} from '../../services/api';
import toast from 'react-hot-toast';

interface SignUpFormData{
    nome: string;
    email: string;
    pass: string;
    repass: string;
}

const SignUp: React.FC = () => {

    const formRef = useRef<FormHandles>(null);
    const history = useHistory();

    const handleSubcribe = useCallback(async (data: SignUpFormData) => {
      if(data.pass === data.repass){
        try {
            formRef.current?.setErrors({});
            const schema = Yup.object().shape({
                nome: Yup.string().required('Nome obrigatório').min(5, 'Mínimo 5 caracteres').max(70, 'Máximo de 70 caracteres'),
                email: Yup.string().required('Email obrigatório').email('Insira um email válido').min(5, 'Mínimo 5 caracteres'),
                pass: Yup.string().required('Senha Obrigatória').min(6, 'Mínimo 6 caracteres').max(12, 'Máximo de 12 caracteres'),
                repass: Yup.string().required('Senha Obrigatória').min(6, 'Mínimo 6 caracteres').max(12, 'Máximo de 12 caracteres'),
            });
            await schema.validate(data, { abortEarly: false, });

            await api.post('cad_user.php', data);
            toast.success('SUCESSO, FAÇA AGORA SEU LOGON');
            // console.log(resp);
            history.push('/');
            

        } catch (err: any) {
          if(err instanceof Yup.ValidationError){
            const errors = getValidationErros(err);
            formRef.current?.setErrors(errors);
            return;
          }
          
          const resp = err.response.statusText;
                          
          toast.error('ERRO AO CADASTRAR: ' + resp);
        }
      } else {
        toast.error('ERRO, AS SENHAS NÃO SÃO IGUAIS');
      }
    }, [history]);

   
    return ( 
    <>
        <Container>
            <img src={logoImg} alt="Método Billings" />
            <br />
            <h3>CADASTRE-SE</h3>
            <Form ref={formRef} onSubmit={handleSubcribe}>
                <Input type="text" name="nome" placeholder="SEU NOME" />
                <Input type="text" name="email" placeholder="SEU EMAIL" />
                <Input type="password" name='pass' placeholder="SUA SENHA" />
                <Input type="password" name='repass' placeholder="SUA SENHA NOVAMENTE" />
                <Button type="submit">cadastrar</Button>                
            

                <div className="outros">
                    <a href="/" className="botao">já tenho cadastro</a>
                    <a href="/esqueciasenha" className="botao">Esqueci a senha</a>
                </div>
            </Form>
        </Container>
        <GlobalStyle />
    </>
    );
}

export default SignUp;